/**
 * clickable badging experience with palette badge component
 *
 * @module views/components/ClickableBadge
 * @memberof -Common
 */
import './ClickableBadge.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from '@ulta/core/components/Button/Button';
import Icon from '@ulta/core/components/Icon/Icon';
import Text from '@ulta/core/components/Text/Text';
import UltaAsset from '@ulta/core/components/UltaAsset/UltaAsset';
import { handleEmptyObjects } from '@ulta/core/utils/handleEmptyObjects/handleEmptyObjects';

/**
 * Represents a ClickableBadge component
 *
 * @method
 * @param { ClickableBadgeProps} props - React properties passed from composition
 * @returns ClickableBadge
 */
export const ClickableBadge = function( { item, ...props } ){
  const { imageIcon, label, itemDetailCard, selectAction } = item;
  const { onClick, openerRef } = handleEmptyObjects( props );
  const LABEL_MAX_LENGTH = 18;

  if( !label ){
    return null;
  }

  return (
    <>
      <div
        className='ClickableBadge'
      >
        <Button
          action={ { dataCaptureData: selectAction?.dataCaptureData } }
          variant='unstyled'
          onClick={ ( e ) => onClick( e ) }
          ref={ openerRef }
          className={ classNames( 'ClickableBadge__button', {
            'ClickableBadge__Focusable': itemDetailCard
          } ) }
        >
          { imageIcon && (
            <UltaAsset { ...imageIcon }
              aspectRatio='1:1'
              width={ 32 }
              height={ 32 }
            /> ) }
          <span className={ classNames( 'ClickableBadge__text', { 'ClickableBadge__text--long': label.length >= LABEL_MAX_LENGTH } ) }>
            <Text htmlTag='span'
              textStyle='label'
            >
              { label }
            </Text>
          </span>
          { itemDetailCard &&
            <Icon
              size={ 's' }
              name='caretForward'
              aria-hidden={ true }
              className='ClickableBadge__icon'
            />
          }
        </Button>
      </div>
    </>
  );
};

/**
 * Property type definitions
 * @typedef ClickableBadgeProps
 * @type {object}
 * @property {object} imageIcon - contains image icon
 * @property {string} label - sets label
 * @property {object} itemDetailCard - contains itemDetailCard
 * @property {function} onClick - Function as the event handler
 */
export const propTypes =  {
  imageIcon: PropTypes.object,
  label: PropTypes.string,
  itemDetailCard: PropTypes.object,
  onClick: PropTypes.func
};

ClickableBadge.propTypes = propTypes;

export default ClickableBadge;
